import React from "react";
import "./index.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-copyright">
        <span>© 2026 Vectech</span>
      </div>
    </footer>
  );
};

export default Footer;
